import { render } from "./csd-vditor.vue?vue&type=template&id=b0f23c82"
import script from "./csd-vditor.vue?vue&type=script&lang=js"
export * from "./csd-vditor.vue?vue&type=script&lang=js"

import "./csd-vditor.vue?vue&type=style&index=0&id=b0f23c82&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__